module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('mt-header', {
    attrs: {
      "title": "账户登录"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    },
    slot: "left"
  }, [_c('mt-button', {
    attrs: {
      "icon": "back"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/register"
    },
    slot: "right"
  }, [_c('mt-button', [_vm._v("注册")])], 1)], 1), _vm._v(" "), _c('form', {
    staticClass: "loginForm",
    attrs: {
      "model": _vm.loginForm
    }
  }, [_c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.username),
      expression: "loginForm.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "用户名"
    },
    domProps: {
      "value": (_vm.loginForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loginForm.password),
      expression: "loginForm.password"
    }],
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.loginForm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loginForm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('section', [_c('mt-button', {
    on: {
      "click": _vm.loginSubmit
    }
  }, [_vm._v("登录")])], 1), _vm._v(" "), _vm._m(0)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "test"
  }, [_c('p', [_vm._v("测试：")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874236/123456")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874239/123456")]), _vm._v(" "), _c('p', [_vm._v("用户名/密码:2014874207/654321")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26b11326","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/login.vue
// module id = 221
// module chunks = 1